module.exports = __webpack_public_path__ + "static/media/bglogin.2475668d.jpg";